import axios from "axios";
import { auth } from "./auth";

const api = axios.create({
	baseURL: process.env.REACT_APP_URL,
	timeout: 10000,
});

// Response interceptor: Handle errors globally
api.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		if (error.response) {
			// Handle 401 Unauthorized errors
			if (error.response.status === 401) {
				auth().logout();
				if (window.location.pathname !== '/login') {
					window.location.href = '/login'; // Redirect to login
					alert('Your session has expired. Please log in now.');
				}
			}
			// Handle other error statuses if needed
			else if (error.response.status === 403) {
				// Example for forbidden access
				alert('You do not have permission to perform this action.');
			}
		}
		return Promise.reject(error);
	}
);

export default api;